import React from "react";
import PropTypes from "prop-types";
import { Col, Container, Row } from "reactstrap";
import { Field } from "formik";
import { ItemTitle } from "../../../commons/elements/index";

const propTypes = {
  product: PropTypes.shape({
    productId: PropTypes.number,
    name: PropTypes.string,
    cost: PropTypes.number,
    currency: PropTypes.string
  }).isRequired,
  selectProduct: PropTypes.func.isRequired
};

function EventProduct(props) {
  const { product, selectProduct } = props;

  return (
    <Container fluid className="product-container">
      <Row>
        <Col className="col-1 fixed-width">
          <Field
            type="radio"
            name="productId"
            className="product-option-radio"
            value={`${product.productId}`}
            onClick={() => selectProduct({ ...product, id: product.productId })}
          />
        </Col>
        <Col>
          <Row>
            <ItemTitle title={product.name} />
          </Row>
          <Row className="event-product-cost">
            {product.currency === "CAD" ? (
              <span>{`CA$${product.cost / 100}`}</span>
            ) : (
              <span>{`$${product.cost / 100}`}</span>
            )}
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

EventProduct.propTypes = propTypes;

export default EventProduct;
